// frontend/src/components/ArtworkPage/NavigationButtons.js
import React from "react";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import "./NavigationButtons.css";

const NavigationButtons = ({
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  loading = false,
}) => {
  return (
    <>
      <button
        onClick={onPrevious}
        disabled={!hasPrevious || loading}
        className="nav-button nav-button-left"
        aria-label="Previous artwork"
      >
        {loading ? (
          <Loader2 className="nav-button-icon nav-loading-spinner" />
        ) : (
          <ChevronLeft className="nav-button-icon" />
        )}
      </button>

      <button
        onClick={onNext}
        disabled={!hasNext || loading}
        className="nav-button nav-button-right"
        aria-label="Next artwork"
      >
        {loading ? (
          <Loader2 className="nav-button-icon nav-loading-spinner" />
        ) : (
          <ChevronRight className="nav-button-icon" />
        )}
      </button>
    </>
  );
};

export default NavigationButtons;
